import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermisosService } from '../services/permisos.service';
import { CLAVES_BODEGA, CLAVE_INVENTARIO_OBRA, ETIQUETAS_SECCION_BODEGA, ETIQUETA_INVENTARIO_OBRA, SECCIONES_BODEGA } from '../constants/bodega-permisos';
import { CLAVES_CATALOGO, ETIQUETAS_SECCION_CATALOGO, SECCIONES_CATALOGO } from '../../modules/catalogo/catalogo-permisos';
import { CLAVES_CENTRAL, ETIQUETAS_SECCION_CENTRAL, SECCIONES_CENTRAL } from '../../modules/bodega-central/bodega-central-permisos';

const LABELS: Record<string, string> = {
  ...Object.fromEntries(SECCIONES_BODEGA.map(s => [CLAVES_BODEGA[s], ETIQUETAS_SECCION_BODEGA[s]])),
  ...Object.fromEntries(SECCIONES_CATALOGO.map(s => [CLAVES_CATALOGO[s], ETIQUETAS_SECCION_CATALOGO[s]])),
  ...Object.fromEntries(SECCIONES_CENTRAL.map(s => [CLAVES_CENTRAL[s], ETIQUETAS_SECCION_CENTRAL[s]])),
  obras:              'Obras',
  [CLAVE_INVENTARIO_OBRA]: ETIQUETA_INVENTARIO_OBRA,
  obra_arriendos:         'Solicitud de maquinaria',
  obra_andamios:          'Andamios y moldajes',
  obra_activos:           'Activos de la obra',
  obra_epp:               'EPP de la obra',
  obra_epp_entrega:       'EPP de la obra',
  obra_epp_urgente:       'EPP de la obra',
  obra_epp_propio:        'Mi EPP',
  obra_cobros:            'Cobros recibidos',
  obra_operadores:        'Operadores de maquinaria',
  obra_bitacora:          'Bitácora de maquinaria',
  obra_bitacora_propia:   'Bitácora propia (operador)',
  presupuesto:        'Presupuesto',
  presupuesto_precios:   'Presupuesto: escribir precios',
  rrhh_costos_cargos:    'RRHH: costos de cargos',
  rrhh_parametros_laborales: 'RRHH: parámetros laborales',
  'gasto-general':    'Gasto General',
  trabajadores:       'Trabajadores',
  trabajadores_obra_resumen: 'Trabajadores de la obra (vista reducida)',
  trabajadores_exportar:     'Exportar trabajadores',
  trabajadores_importar:     'Importar trabajadores',
  'rrhh-catalogos':   'Catálogos RRHH',
  cuadrillas:         'Cuadrillas',
  produccion:         'Producción',
  evaluacion:         'Evaluación de desempeño',
  solicitudes:        'Abastecimiento',
  combustible:        'Combustible',
  reportes:           'Reportes',
  admin:              'Administración',
  configuracion:      'Configuración',
  empresas_obras: 'Empresas y obras',
  zonificacion_unidades: 'Zonificación y unidades',
  documentos:         'Documentos',
  documentos_gestionar: 'Gestionar documentos',
  documentos_finanzas: 'el estado de pago de los documentos',
  empresas:           'Empresas',
  soporte_admin:      'Administración de Soporte TI',
  'causas-laborales':    'Causas Laborales',
  'presupuestos-legales': 'Presupuestos Legales',
  tarjetas:              'Tarjetas Digitales',
  'facturas-servicio':   'Facturas de Servicio',
  comercial_leads:          'Administración de Leads',
  comercial_vendedoras:     'Administración de Vendedoras',
  comercial_ventas:         'Ventas',
};

/** Cómo se nombra un módulo (o «A o B» si son varios) en el aviso de acceso denegado. */
export const etiquetaDeClaves = (claves: string[]): string => [...new Set(claves.map(c => LABELS[c] ?? c))].join(' o ');

/** `route.data.claveModulo` acepta un string (comportamiento de siempre) o un array — en ese
 *  caso el acceso se otorga si el usuario tiene CUALQUIERA de las claves listadas (ej. /comercial,
 *  que debe dejar entrar con solo comercial_leads, solo comercial_vendedoras, o ambos). */
export const permissionGuard: CanActivateFn = (route) => {
  const permisos = inject(PermisosService);
  const router   = inject(Router);
  const clave    = route.data?.['claveModulo'] as string | string[] | undefined;

  const claves = Array.isArray(clave) ? clave : clave ? [clave] : [];
  if (claves.length === 0 || claves.some(c => permisos.puedeVer(c))) return true;

  permisos.denegarAcceso(etiquetaDeClaves(claves));
  return router.createUrlTree(['/sin-acceso']);
};
